import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.weekly.deposits,
    (task) => {
        return {
            task
        }
    }
)